export default {
  /**
   * Sets the state entities value.
   *
   * @param {Object} state
   * @param {Array} entities
   */
  SET_ENTITIES(state, entities) {
    state.entities = entities
  },

  /**
   * Sets the state loading value.
   *
   * @param {Object} state
   * @param {boolean} loading
   */
  SET_LOADING(state, loading) {
    state.loading = loading
  },
}
